// Client-side wrapper around buildReaderStub. Looks up an existing
// reader doc by authUid and returns it; if none exists, creates a stub
// using the canonical shape and returns it.
//
// Used by ARC apply paths in src/author/AvailableArcs.js to prevent
// stranded applicants whose authUid has no matching reader doc in the
// top-level readers/ collection.
//
// Out of scope for this helper: email-fallback linking when authUid
// does not match. That is tracked separately in the orphan-cleanup
// backlog and will be handled by a future PR.

import {
  collection, query, where, limit,
  getDocs, addDoc, serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import { buildReaderStub } from './buildReaderStub';

export async function ensureReaderDoc({
  currentReader,
  authorId,
  name,
  source = 'arc_apply_stub',
}) {
  if (!currentReader?.uid)   throw new Error('ensureReaderDoc: currentReader.uid required');
  if (!currentReader?.email) throw new Error('ensureReaderDoc: currentReader.email required');
  if (!authorId)             throw new Error('ensureReaderDoc: authorId required');

  const readers = collection(db, 'readers');
  const existing = await getDocs(
    query(readers, where('authUid', '==', currentReader.uid), limit(1))
  );
  if (!existing.empty) {
    const d = existing.docs[0];
    return { id: d.id, ...d.data() };
  }

  const stub = buildReaderStub({
    authUid: currentReader.uid,
    email: currentReader.email,
    name: name || currentReader.displayName || '',
    authorId,
    source,
    createdAt: serverTimestamp(),
  });
  const ref = await addDoc(readers, stub);
  return { id: ref.id, ...stub };
}
